export interface WorkPaginatedResult {
    page: number;
    pageSize: number;
    totalItems: string | null;
    items: Work[] | null;
}

export interface Work {
    assignedTo: string | null;
    assignedToName: string | null;
    equipmentClass: string | null;
    equipmentDescription: string | null;
    equipmentID: string | null;
    equipmentOrg: string | null;
    equipmentParentClass: string | null;
    equipmentParentDescription: string | null;
    equipmentParentID: string | null;
    equipmentParentType: string | null;
    equipmentType: string | null;
    gisObjID: number;
    workOrderDate: string | null;
    workOrderDescription: string | null;
    workOrderDue: string | null;
    workOrderID: string | null;
    workOrderPMPlan: string | null;
    workOrderStatus: string | null;
    workOrderStatusCode: string | null;
    workOrderType: string | null;
    workOrderTypeCode: string | null;
    otherProps: { [key: string]: string | null } | null;
}

export interface GetWorkOrdersParams {
    page?: number;
    pageSize?: number;
    assignedTo?: string;
    gisObjId?: number;
    statusCodes?: string;
    classCodes?: string;
}

export type WorkOrderClassCode = "*" | "DIR"; // "*" for most objects, or "DIR" for Lys
export const DEFAULT_FDV_CLASS_CODE = "*";

export interface CreateWorkOrderRequest {
    description?: string | null;
    gisObjId?: number | null;
    typeCode?: string | null;
    statusCode?: string | null;
    classCode?: WorkOrderClassCode;
}

export interface SuccessMessage {
    success: boolean;
    message: string;
}

export interface WorkOrdersLightParameterSyncResult {
    resultsByWorkOrderId: Record<string, SuccessMessage>[];
    layerId: number;
    globalId: string;
    gdbVersion: string;
    message: string;
    featureNotFound: boolean;
}

export interface SyncFeatureToFDVRequest {
    layerId?: number | null;
    globalId?: string | null;
    gdbVersion?: string | null;
}

export enum WorkOrderTypes {
    REMOVAL = "FJ", // shall be used for fjerning
    RENEWALMODIFICATION = "FO", // shall be used for nedlegging, and for editing of existing objects
    PROJECT_NEW_CONSTRUCTION = "PR", // shall be used for new objects
}

export interface DocumentUploadRequest {
    fileName?: string | null;
    base64Content?: string | null;
    description: string;
    attachToGisObjectId?: number | null;
    attachToWorkOrderId?: string | null;
}

// This is hardcoded as FDV does not provide an API for fetching these
// Also, only a subset is relevant for NFS
export const WORK_ORDER_TYPES = [
    { code: "*", description: "Alle arbeidsordretyper" },
    { code: "AVHD", description: "Avhending" },
    { code: "BRKD", description: "Havari" },
    { code: "CAL", description: "Kalibrering" },
    { code: "EH", description: "Eiendomshendelse" },
    { code: "FJ", description: "Fjerning" }, // shall be used for fjerning
    { code: "FO", description: "Fornying/Modifikasjon/Ombygging" }, // shall be used for nedlegging, and for editing of existing objects
    { code: "FV", description: "Tilsyn/Forebyggende vedlikehold" },
    { code: "IK", description: "Internkontroll" },
    { code: "IN", description: "Inspeksjon/Tilstandskontroll" },
    { code: "IS", description: "Direkte uttak" },
    { code: "KART", description: "Kartlegging" },
    { code: "KV", description: "Korrigerende vedlikehold" },
    { code: "LOGG", description: "Loggbok" },
    { code: "MEC", description: "Flerutstyr underordnet" },
    { code: "NAV", description: "Navigasjonsvarsel" },
    { code: "PM", description: "Systemkode (FV)" },
    { code: "PR", description: "Prosjekt/Nyanlegg" }, // shall be used for new objects
    { code: "RP", description: "Reparerbare reservedeler" },
    { code: "SL", description: "SlukningsAO" },
    { code: "ST", description: "Stående arbeidsordre" },
] as const;
